import { render } from "./RootItem.vue?vue&type=template&id=7c4542b3&scoped=true"
import script from "./RootItem.vue?vue&type=script&lang=js"
export * from "./RootItem.vue?vue&type=script&lang=js"

import "./RootItem.vue?vue&type=style&index=0&id=7c4542b3&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/demo-plus.centrodeglaucoma.com/darmin-plus-modular/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c4542b3"]])

export default __exports__